export default "__VITE_ASSET__9eaaf105__"